import { useSuspenseQuery } from '@tanstack/react-query'
import {
  Outlet,
  createFileRoute,
  useRouteContext,
} from '@tanstack/react-router'
import BookingDetail from '@/components/my-booking/booking-detail'
import { getBookingQueryOptions } from '@/queries/query'

export const Route = createFileRoute('/my-booking/$id/view')({
  component: RouteComponent,
})

function RouteComponent() {
  const isAuthenticated = useRouteContext({
    strict: false,
    select: (s) => s.authContext?.isAuthenticated ?? false,
  })
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })

  const {
    data: { data: bookingData },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))

  return (
    <>
      <BookingDetail
        parentTitle={isAuthenticated ? 'My Booking' : 'Manage Booking'}
        parentTo={isAuthenticated ? '/my-booking/list' : '/manage-booking'}
        booking={bookingData.booking}
      />
      <Outlet />
    </>
  )
}
